(function () {
  document.documentElement.classList.add('js-ready');

  window.requestAnimationFrame(function () {
    document.documentElement.classList.add('is-loaded');
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.site-header__mobile-panel a');
    var menu = event.target.closest('.site-header__mobile-menu');

    if (link && menu) {
      menu.removeAttribute('open');
    }
  });
})();

